module.exports = __webpack_public_path__ + "img/MechanicalGroup.928f8e79.jpg";